import { render, staticRenderFns } from "./Tax.ui.vue?vue&type=template&id=14b21b3d&scoped=true"
import script from "./Tax.ui.vue?vue&type=script&lang=js"
export * from "./Tax.ui.vue?vue&type=script&lang=js"
import style0 from "./Tax.ui.vue?vue&type=style&index=0&id=14b21b3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b21b3d",
  null
  
)

export default component.exports